"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consume = exports.provide = void 0;
/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */

var serviceStack = [];

var provide = function provide(service, fn) {
  serviceStack.push(service);
  var result = fn(service);
  serviceStack.pop();
  return result;
};

exports.provide = provide;

var consume = function consume(fn) {
  return fn(serviceStack[serviceStack.length - 1]);
};

exports.consume = consume;